import { api } from '../api';

import type {
    EmployeePortalCompetenciesUpdateRequest,
    MultiplePillarsPerObjectiveUpdateRequest,
    ObjectiveWithoutPillarUpdateRequest,
    PerformanceCompanyPreferencesResponse,
    PerformanceCompanyPreferencesUpdateRequest,
    StrategicVisionUpdateRequest,
} from '@/types/performanceCompanyPreferences';

export default {
    async getCompanyPreferences(): Promise<PerformanceCompanyPreferencesResponse> {
        const response = await api.get('/performancecompanypreferences');

        return response.data;
    },

    async updateCompanyPreferences(
        request: PerformanceCompanyPreferencesUpdateRequest,
    ): Promise<PerformanceCompanyPreferencesResponse> {
        const response = await api.put('/performancecompanypreferences', request);

        return response.data;
    },

    async updateStrategicVision(
        request: StrategicVisionUpdateRequest,
    ): Promise<PerformanceCompanyPreferencesResponse> {
        const response = await api.put('/performancecompanypreferences/StrategicVision', request);

        return response.data;
    },

    async updateMultiplePillarsPerObjective(
        request: MultiplePillarsPerObjectiveUpdateRequest,
    ): Promise<PerformanceCompanyPreferencesResponse> {
        const response = await api.put(
            '/performancecompanypreferences/MultiplePillarsPerObjective',
            request,
        );

        return response.data;
    },

    async updateObjectiveWithoutPillar(
        request: ObjectiveWithoutPillarUpdateRequest,
    ): Promise<PerformanceCompanyPreferencesResponse> {
        const response = await api.put(
            '/performancecompanypreferences/ObjectiveWithoutPillar',
            request,
        );

        return response.data;
    },

    async updateEmployeePortalCompetencies(
        request: EmployeePortalCompetenciesUpdateRequest,
    ): Promise<PerformanceCompanyPreferencesResponse> {
        const response = await api.put(
            '/performancecompanypreferences/EmployeePortalCompetencies',
            request,
        );

        return response.data;
    },
};
